import { frontendURL } from '../../../helper/URLHelper';
import TaccTasksPage from './TaccTasksPage.vue';
import TaccRemindersPage from './TaccRemindersPage.vue';

const commonMeta = {
  permissions: ['administrator', 'agent', 'custom_role'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tacc/tasks'),
    name: 'tacc_tasks_index',
    component: TaccTasksPage,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/tacc/reminders'),
    name: 'tacc_reminders_index',
    component: TaccRemindersPage,
    meta: commonMeta,
  },
];
